import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <div className="pt-12 pb-8 px-4 max-w-4xl mx-auto text-center" data-id="element-168">
      <div className="inline-block bg-white border border-brand-border rounded-full px-4 py-1.5 font-semibold text-brand-title mb-4 text-[12px] tracking-[0.15em] uppercase shadow-sm" data-id="element-169">
        💃 INSTRUCTORAS DE ZUMBA EN ESPAÑA
      </div>

      <h1 className="font-display text-brand-title md:text-6xl font-bold tracking-tight mb-6 text-[32px] leading-tight" data-id="element-170">
        Deja de improvisar tus clases y consigue que tus alumnas quieran volver
        cada semana.
      </h1>

      <div className="my-6 flex justify-center" data-id="element-171">
        <img src="https://cdn.magicpatterns.com/uploads/db55hm39pPvsCQxNyf8uNx/zumba_mockup_webp_sin_fondo.webp" alt="El Manual del Instructor de Zumba — 6 Tomos + 6 Bonos" width="800" height="800" fetchPriority="high" loading="eager" decoding="async" className="w-full max-w-2xl" data-id="element-172" />
      </div>

      <p className="md:text-2xl text-brand-text font-semibold mb-6 tracking-wide font-body text-[14px]" data-id="element-173">
        480 páginas de pura ejecución. No es un manual de baile, es el sistema
        operativo de tu negocio: Marketing local, psicología de precios y 12
        meses de programación lista para usar hoy mismo.
      </p>

      <button onClick={scrollToPricing} className="bg-gradient-gold hover:bg-brand-ctaHover text-white font-bold text-xl md:text-2xl py-4 px-8 rounded-2xl transition-colors w-full md:w-auto mb-6 tracking-wide shadow-gold-glow" data-id="element-174">
        🚀 QUIERO MI MANUAL AHORA
      </button>

      <div className="flex items-center justify-center gap-2 mb-6 text-sm flex-wrap" data-id="element-175">
        <div className="flex text-brand-title" data-id="element-176">⭐⭐⭐⭐⭐</div>
        <span className="text-brand-text font-medium" data-id="element-177">4.9/5</span>
        <span className="text-brand-textMuted" data-id="element-178">·</span>
        <span className="text-brand-text font-medium" data-id="element-179">
          🔥 +400 instructoras en España
        </span>
        <span className="text-brand-textMuted" data-id="element-180">·</span>
        <span className="text-brand-text font-medium" data-id="element-181">
          ⚡ Acceso en 2 minutos
        </span>
      </div>
    </div>;
}